import S from "common/service/sanctuary";
import React, { Fragment } from "react";
import { compose } from "ramda";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Form from "common/mdc/form/index";
import Button from "common/mdc/button";
import Dialog from "common/mdc/dialog";
import { actions as jobActions } from "@sma/store/job/jobs";
import "../previewNewJob/previewNewJob.scss";
import DatetimeInput from 'common/mdc/form/datetime';
import { JOB_CONFIGURATION_GET_COMMANDS } from '../../../../constants';
import { scheduleGetTypeJob } from "../../../../utils";

class PreviewNewJob extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleRunJob = this.handleRunJob.bind(this);
   
  }

  handleRunJob() {
    scheduleGetTypeJob(this.props.newJobEntries, this.props.runGetJob);
  }

  render() {

    const {
      jobName,
      jobType,
      selectedGroupOrMeters,
      configAction,
      cmdType,
      isActive,
      timeout,
      isCallBackEnabled,
      jobMeterCallback,
      jobCallback,
      jobCallbackUrl,
    } = this.props.newJobEntries || {};

    const {

      showPreviewJobDialog,
      onClose,
      onClick,

    } = this.props;

    const selectedCommand = JOB_CONFIGURATION_GET_COMMANDS.find(cmnd => cmnd.id === cmdType)

    const buttons = (
      <Fragment>
        <Button onClick={()=>showPreviewJobDialog(false)}  className="mdc-dialog__footer__button">
          cancel
        </Button>
        <Button raised onClick={()=>this.handleRunJob()} className="mdc-dialog__footer__button">
          confirm & run job
        </Button>
      </Fragment>
    );

    return (
      <Dialog
        title={"Job Preview"}
        onClose={onClose}
        buttons={buttons}
        onClick={onClick}
      >
        <div className="preview-job-content">
          <Form>
            <div className="job-step-preview job-details-preview">
              <h3 className="step-title">Job Details</h3>
              <div className="preview-row">
                <div className="preview-info">
                 <label className="label">Job Name:</label>
                  <span className="value">{ jobName }</span>
                </div>
                <div className="preview-info">
                 <label className="label">Job Type:</label>
                  <span className="value">{ `${jobType === "MeterConf" ? "Meter Configuration" : null}` }</span>
                </div>
              </div>
              <div className="preview-row">
                <div className="preview-info">
                 <label className="label">Callback:</label>
                  <span className="value">{isCallBackEnabled ? "Enabled" : "Not Enabled"}</span>
                </div>
              </div>
              {
                isCallBackEnabled ? 
                (<div>
                <div className="preview-row">
                  <div className="preview-info">
                    <label className="label">JOB_METER_CALLBACK:</label>
                    <span className="value">{ String(jobMeterCallback).toLocaleUpperCase() }</span>
                  </div>
                  <div className="preview-info">
                    <label className="label">JOB_CALLBACK:</label>
                    <span className="value">{ String(jobCallback).toLocaleUpperCase() }</span>
                  </div>
                </div>
                <div className="preview-row">
                  <div className="preview-info">
                    <label className="label">Callback URL:</label>
                    <span className="value">{ jobCallbackUrl }</span>
                  </div>
                </div>
                </div>
                )
                 : null
              }
            </div>

            <div className="job-step-preview meter-selection-preview">
              <h3 className="step-title">Meter Selection</h3>
              <div className="preview-row">
                <div className="preview-info">
                  {
                    selectedGroupOrMeters["name"] === undefined ?
                    <label className="label">Meter Serial Number(s):</label> :
                    <label className="label">Selected Group:</label>
                  }
                  {
                    selectedGroupOrMeters["name"] === undefined ?
                    <span className="value" title={selectedGroupOrMeters.join(", ")}>{ selectedGroupOrMeters.join(", ") }</span> :
                    <span className="value">{ `${selectedGroupOrMeters["name"]} - ${selectedGroupOrMeters["count"]} meter(s)` }</span>
                  }
                  
                </div>
              </div>
            </div>

            <div className="job-step-preview config-details-preview">
              <h3 className="step-title">Configuration Details</h3>
              <div className="preview-row">
                <div className="preview-info">
                  <label className="label">Configuration Action:</label>
                  <span className="value">{ configAction.toLocaleUpperCase() }</span>
                </div>
                <div className="preview-info">
                  <label className="label">Command Type:</label>
                  <span className="value">{ selectedCommand["name"] }</span>
                </div>
              </div>
              <div className="preview-row">
                <div className="preview-info">
                  <label className="label">Active:</label>
                  <span className="value">{ String(isActive).toLocaleUpperCase() }</span>
                </div>
                <div className="preview-info">
                  <label className="label">Timeout:</label>
                  <span className="value date-time-value">{ timeout && <DatetimeInput value={timeout} disabled/> }</span>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Dialog>
    );
  }
}

PreviewNewJob.defaultProps = {
  newJobEntries: {},
};

export default compose(
  connect(
    (state) => ({
      //state
      newJobEntries: state.job.jobs.createJob
    }),
    {
      //actions
        showPreviewJobDialog: jobActions.showPreviewJobDialog,
        runGetJob: jobActions.runGetJob,
    }
  ),
  injectIntl
)(PreviewNewJob);
